import { MODULES_ENUM } from "../data/modules";

interface SubMenu {
    subMenuName: string;
    subMenuIcon: string;
    url: string;
    idMenu: number;
    idModules: MODULES_ENUM;
}

interface MenuItem {
    menuName: string;
    menuIcon: string;
    url: string;
    idMenu: number[];
    open: boolean;
    idModules: MODULES_ENUM[] | number[];
    subMenu: SubMenu[];
}

export const SUBDOMAIN_MENU: MenuItem[] = [
    //* PERFIL
    {
        menuName: 'NAV.myProfile',
        menuIcon: 'ic-user',
        url: 'perfil/admin',
        idMenu: [0],
        open: false,
        idModules: [MODULES_ENUM.PROFILE],
        subMenu: []
    },
    //* PERFIL
    // {
    //     menuName: 'Estadísticas',
    //     menuIcon: 'ic-statistics',
    //     url: 'estadisticas',
    //     idMenu: [55],
    //     open: false,
    //     idModules: [MODULES_ENUM.STATISTICS],
    //     subMenu: [],
    // },
    //* REPORTES
    // {
    //     menuName: 'NAV.kpi',
    //     menuIcon: 'ic-reportes',
    //     url: 'panel',
    //     idMenu: [1, 47],
    //     open: false,
    //     idModules: [19, 43],
    //     subMenu: [
    //         {
    //             subMenuName: 'Eventos',
    //             subMenuIcon: 'ic-events-kpi',
    //             url: 'panel',
    //             idMenu: 1,
    //             idModules: 19
    //         },
    //         {
    //             subMenuName: 'Estado de fuerza',
    //             subMenuIcon: 'ic-strength-status',
    //             url: 'estado-de-fuerza',
    //             idMenu: 47,
    //             idModules: 43
    //         }
    //     ]
    // },
    //* TIPOS DE USUARIOS
    // {
    //     menuName: 'NAV.accountsAndRoles',
    //     menuIcon: 'ic-users',
    //     url: 'tipo-usuarios',
    //     idMenu: [3],
    //     open: false,
    //     idModules: [26],
    //     subMenu: []
    // },
    //* POLICÍAS
    {
        menuName: 'NAV.polices',
        menuIcon: 'ic-police',
        url: 'policias',
        idMenu: [5],
        open: false,
        idModules: [MODULES_ENUM.POLICES],
        subMenu: []
    },
    //* EVENTOS
    {
        menuName: 'NAV.events',
        menuIcon: 'ic-events',
        url: 'eventos',
        idMenu: [7],
        open: false,
        idModules: [MODULES_ENUM.EVENTS],
        subMenu: []
    },
    //* DASHBOARD (TABLEROS) — un tablero por dependencia (Policía, Justicia Cívica)
    {
        menuName: 'NAV.dashboards',
        menuIcon: 'ic-reportes',
        url: '',
        idMenu: [69, 70],
        open: false,
        // El idModules del padre no se evalúa cuando hay submenú (ver MenuService.filterMenu);
        // la visibilidad depende de que al menos un subítem pase el filtro.
        idModules: [MODULES_ENUM.DASHBOARDS],
        subMenu: [
            {
                subMenuName: 'NAV.dashboardPolice',
                subMenuIcon: 'ic-reportes',
                url: 'tableros/policia',
                idMenu: 69,
                idModules: MODULES_ENUM.DASHBOARDS
            },
            {
                subMenuName: 'NAV.dashboardCivicJustice',
                subMenuIcon: 'ic-reportes',
                url: 'tableros/justicia-civica',
                idMenu: 70,
                idModules: MODULES_ENUM.DASHBOARDS
            }
        ]
    },
    //* VARIABLES DE SISTEMA
    // {
    //     menuName: 'NAV.systemVariables',
    //     menuIcon: 'ic-variable',
    //     url: 'variables-sistema',
    //     idMenu: [11],
    //     open: false,
    //     idModules: [4],
    //     subMenu: []
    // },
    //* UNIDAD DE PATRULLAJE
    {
        menuName: 'NAV.patrolUnit',
        menuIcon: 'ic-patrulla',
        url: '',
        idMenu: [8, 1, 71, 72],
        open: false,
        idModules: [MODULES_ENUM.PATROL_UNIT, MODULES_ENUM.ASSIGNED_UNITS, MODULES_ENUM.UNIT_TRACKING, MODULES_ENUM.PATROL_WORKSHOP],
        subMenu: [
            {
                subMenuName: 'NAV.patrolUnit',
                subMenuIcon: 'ic-patrulla',
                url: 'unidad-patrullaje',
                idMenu: 8,
                idModules: MODULES_ENUM.PATROL_UNIT
            },
            {
                subMenuName: 'NAV.assignedUnit',
                subMenuIcon: 'ic-listas',
                url: 'unidades-asignadas',
                idMenu: 10,
                idModules: MODULES_ENUM.ASSIGNED_UNITS
            },
            {
                subMenuName: 'NAV.unitControl',
                subMenuIcon: 'ic-listas',
                url: 'control-de-unidades',
                idMenu: 59,
                idModules: MODULES_ENUM.ASSIGNED_UNITS
            },
            {
                subMenuName: 'NAV.unitTrack',
                subMenuIcon: 'ic-patrullaje',
                url: 'seguimiento-unidades',
                idMenu: 71,
                idModules: MODULES_ENUM.UNIT_TRACKING
            },
            {
                subMenuName: 'NAV.patrolWorkshop',
                subMenuIcon: 'ic-patrulla',
                url: 'taller-patrullas',
                idMenu: 72,
                idModules: MODULES_ENUM.PATROL_WORKSHOP
            }
        ]
    },
    //* RECURSOS HUMANOS
    {
        menuName: 'NAV.resourcesHuman',
        menuIcon: 'ic-employees',
        url: '',
        idMenu: [9, 6, 15, 23, 31, 37, 57, 60, 61],
        open: false,
        idModules: [
            MODULES_ENUM.EMPLOYEES,
            MODULES_ENUM.EMPLOYEE_PERMISSIONS,
            28,
            MODULES_ENUM.PLACES,
            30,
            39,
            MODULES_ENUM.SHIFT_SCHEDULE,
            MODULES_ENUM.ASSIGNMENTS,
            MODULES_ENUM.INCIDENTS
        ],
        subMenu: [
            {
                subMenuName: 'NAV.employess',
                subMenuIcon: 'ic-employees',
                url: 'empleados',
                idMenu: 9,
                idModules: MODULES_ENUM.EMPLOYEES
            },
            {
                subMenuName: 'NAV.permissions',
                subMenuIcon: 'ic-incidents',
                url: 'permisos',
                idMenu: 6,
                idModules: MODULES_ENUM.EMPLOYEE_PERMISSIONS
            },
            {
                subMenuName: 'NAV.shifts',
                subMenuIcon: 'ic-employees',
                url: 'turnos',
                idMenu: 41,
                idModules: MODULES_ENUM.SHIFT_SCHEDULE
            },
            {
                subMenuName: 'NAV.controlPlaces',
                subMenuIcon: 'ic-plazas',
                url: 'control-plazas',
                idMenu: 23,
                idModules: MODULES_ENUM.PLACES
            },
            {
                subMenuName: 'NAV.assignments',
                subMenuIcon: 'ic-assignar',
                url: 'asignaciones',
                idMenu: 60,
                idModules: MODULES_ENUM.ASSIGNMENTS
            },
            {
                subMenuName: 'NAV.incidents',
                subMenuIcon: 'ic-incidents',
                url: 'incidencias',
                idMenu: 61,
                idModules: MODULES_ENUM.INCIDENTS
            },
        ]
    },
    //* INVENTARIO
    {
        menuName: 'NAV.inventory',
        menuIcon: 'ic-inventory',
        url: 'inventario',
        idMenu: [13],
        open: false,
        idModules: [MODULES_ENUM.INVENTORY],
        subMenu: []
    },
    //* CONSEJO DE HONOR Y JUSTICIA
    {
        menuName: 'Consejo Honor y Justicia',
        menuIcon: 'ic-inventory',
        url: 'consejo-honor-y-justicia',
        idMenu: [53],
        open: false,
        idModules: [MODULES_ENUM.HONOR_AND_JUSTICE_COUNCIL],
        subMenu: []
    },
    //* CURSOS DE EMPLEADOS
    {
        menuName: 'Cursos de empleados',
        menuIcon: 'ic-courses',
        url: 'cursos',
        idMenu: [54],
        open: false,
        idModules: [MODULES_ENUM.EMPLOYEE_COURSES],
        subMenu: []
    },
    //* SIAGEM
    // {
    //     menuName: 'NAV.siagem',
    //     menuIcon: 'ic-siagem',
    //     url: 'siagem',
    //     idMenu: [16],
    //     open: false,
    //     idModules: [10],
    //     subMenu: []
    // },
    //* SMART PSS
    // {
    //     menuName: 'NAV.smartPss',
    //     menuIcon: 'ic-camera',
    //     url: 'smart-pss',
    //     idMenu: [14],
    //     open: false,
    //     idModules: [11],
    //     subMenu: []
    // },
    //* ADMINISTRACIÓN DE CATÁLOGOS
    // {
    //     menuName: 'NAV.catalogManagement',
    //     menuIcon: 'ic-catalog',
    //     url: 'administracion-catalogos',
    //     idMenu: [12],
    //     open: false,
    //     idModules: [2],
    //     subMenu: []
    // },
    //* CONCILIACIÓN
    {
        menuName: 'NAV.conciliationCheckin',
        menuIcon: 'ic-check-weapons',
        url: 'conciliacion',
        idMenu: [20],
        open: false,
        idModules: [MODULES_ENUM.ATTENDANCE_CONCILIATION],
        subMenu: []
    },
    //* ASISTENCIA
    {
        menuName: 'NAV.presenceCheckin',
        menuIcon: 'ic-asistencia',
        url: 'asistencia',
        idMenu: [17],
        open: false,
        idModules: [MODULES_ENUM.ATTENDANCE_ENTRIES],
        subMenu: []
    },
    // {
    //     menuName: 'NAV.presenceCheckin',
    //     menuIcon: 'ic-asistencia',
    //     url: '',
    //     idMenu: [17, 36],
    //     open: false,
    //     idModules: [MODULES_ENUM.ATTENDANCE_ENTRIES, MODULES_ENUM.ATTENDANCE_EXITS],
    //     subMenu: [
    //         {
    //             subMenuName: 'NAV.presenceCheckin',
    //             subMenuIcon: 'ic-listas',
    //             url: 'asistencia/check-in',
    //             idMenu: 17,
    //             idModules: MODULES_ENUM.ATTENDANCE_ENTRIES
    //         },
    //         {
    //             subMenuName: 'NAV.presenceCheckout',
    //             subMenuIcon: 'ic-listas',
    //             url: 'asistencia/check-out',
    //             idMenu: 36,
    //             idModules: MODULES_ENUM.ATTENDANCE_EXITS
    //         }
    //     ]
    // },
    //* IPH
    {
        menuName: 'NAV.iph',
        menuIcon: 'ic-iph',
        url: 'iph',
        idMenu: [19],
        open: false,
        idModules: [MODULES_ENUM.IPH],
        subMenu: []
    },
    //* ARMERO
    {
        menuName: 'NAV.gunsmith',
        menuIcon: 'ic-ARMERO',
        url: '',
        idMenu: [18, 39],
        open: false,
        idModules: [MODULES_ENUM.ARMORY, MODULES_ENUM.WEAPONS_OR_DEVICES_EXIT_CONTROL],
        subMenu: [
            {
                subMenuName: 'NAV.armory',
                subMenuIcon: 'ic-ARMERO',
                url: 'armeria',
                idMenu: 18,
                idModules: MODULES_ENUM.ARMORY
            },
            {
                subMenuName: 'NAV.armoryControl',
                subMenuIcon: 'ic-listas',
                url: 'armeria/control',
                idMenu: 39,
                idModules: MODULES_ENUM.WEAPONS_OR_DEVICES_EXIT_CONTROL
            }
        ]
    },
    //* CERTIFICATION
    {
        menuName: 'NAV.medicalCertification',
        menuIcon: 'ic-medical-certification',
        url: 'certificacion-medica',
        idMenu: [21],
        open: false,
        idModules: [MODULES_ENUM.MEDICAL_CERTIFICATION],
        subMenu: []
    },
    //* AUDIENCIAS
    {
        menuName: 'NAV.hearings',
        menuIcon: 'ic-audiencia',
        url: '',
        idMenu: [22, /*25, 26, 27*/],
        open: false,
        idModules: [MODULES_ENUM.COURT_HEARINGS/*22, 23, 32, 33*/],
        subMenu: [
            {
                subMenuName: 'NAV.orden',
                subMenuIcon: 'ic-orden-hearing',
                url: 'audiencias/orden',
                idMenu: 22,
                idModules: MODULES_ENUM.COURT_HEARINGS
            },
            // {
            //     subMenuName: 'NAV.transit',
            //     subMenuIcon: 'ic-transit-hearing',
            //     url: 'audiencias/transito',
            //     idMenu: 25,
            //     idModules: 23
            // },
            // {
            //     subMenuName: 'NAV.alcohol',
            //     subMenuIcon: 'ic-alcohol-hearing',
            //     url: 'audiencias/alcoholimetro',
            //     idMenu: 26,
            //     idModules: 32
            // },
            // {
            //     subMenuName: 'NAV.orden-ngc',
            //     subMenuIcon: 'ic-orden-ngc-hearing',
            //     url: 'audiencias/orden-ngc',
            //     idMenu: 27,
            //     idModules: 33
            // }
        ]
    },
    //* RESUMEN DE AUDIENCIAS
    // {
    //     menuName: 'NAV.resumenAudiencias',
    //     menuIcon: 'ic-audiencia',
    //     url: 'resumen-audiencias',
    //     idMenu: [40],
    //     open: false,
    //     idModules: [40],
    //     subMenu: []
    // },
    //* ASUNTOS INTERNOS
    {
        menuName: 'Asuntos internos',
        menuIcon: 'ic-audiencia',
        url: 'asuntos-internos',
        idMenu: [48],
        open: false,
        idModules: [MODULES_ENUM.INTERNAL_AFFAIRS],
        subMenu: []
    },
    //* INFRACCIONES
    // {
    //     menuName: 'NAV.Infractions',
    //     menuIcon: 'ic-infractions',
    //     url: '',
    //     idMenu: [28, 29, 30],
    //     open: false,
    //     idModules: [18, 34, 35],
    //     subMenu: [
    //         {
    //             subMenuName: 'NAV.InfractionsVehicle',
    //             subMenuIcon: 'ic-employees',
    //             url: 'violaciones/transito',
    //             idMenu: 28,
    //             idModules: 18
    //         },
    //         {
    //             subMenuName: 'NAV.breathalyzerViolations',
    //             subMenuIcon: 'ic-incidents',
    //             url: 'infacciones/breathalyser',
    //             idMenu: 29,
    //             idModules: 34
    //         },
    //         {
    //             subMenuName: 'NAV.ngcOrderViolations',
    //             subMenuIcon: 'ic-check-in-true',
    //             url: 'violaciones/orden/ngc',
    //             idMenu: 30,
    //             idModules: 35
    //         }
    //     ]
    // },
    //* TFC
    // {
    //     menuName: 'NAV.consultationtfcmanagement',
    //     menuIcon: 'ic-consultationtfcmanagement',
    //     url: '',
    //     idMenu: [24, 42, 43, 44, 45],
    //     open: false,
    //     idModules: [21],
    //     subMenu: [
    //         {
    //             subMenuName: 'NAV.orden',
    //             subMenuIcon: 'ic-orden-hearing',
    //             url: 'consultations-tfc-management/orden',
    //             idMenu: 42,
    //             idModules: 21
    //         },
    //         {
    //             subMenuName: 'NAV.transit',
    //             subMenuIcon: 'ic-transit-hearing',
    //             url: 'consultations-tfc-management/transito',
    //             idMenu: 43,
    //             idModules: 21
    //         },
    //         {
    //             subMenuName: 'NAV.alcohol',
    //             subMenuIcon: 'ic-alcohol-hearing',
    //             url: 'consultations-tfc-management/alcoholimetro',
    //             idMenu: 44,
    //             idModules: 21
    //         },
    //         {
    //             subMenuName: 'NAV.orden-ngc',
    //             subMenuIcon: 'ic-orden-ngc-hearing',
    //             url: 'consultations-tfc-management/orden-ngc',
    //             idMenu: 45,
    //             idModules: 21
    //         }
    //     ]
    // },
    //* GPS
    // TODO: Eliminación en caso que no necesiten este modulo
    // {
    //     menuName: 'NAV.unitTrack',
    //     menuIcon: 'ic-patrullaje',
    //     url: 'seguimientogps',
    //     idMenu: [32],
    //     open: false,
    //     idModules: [37],
    //     subMenu: []
    // },
    //* DETENIDOS
    {
        menuName: 'NAV.arrested',
        menuIcon: 'ic-arrested-pending',
        url: '',
        idMenu: [33, 46, 38],
        open: false,
        idModules: [
            MODULES_ENUM.DETAINEES,
            MODULES_ENUM.PENDING_EXITS,
            MODULES_ENUM.DETAINEES_HISTORY
        ],
        subMenu: [
            {
                subMenuName: 'NAV.detentions',
                subMenuIcon: 'ic-jail',
                url: 'detenidos',
                idMenu: 33,
                idModules: MODULES_ENUM.DETAINEES
            },
            {
                subMenuName: 'Salidas pendientes',
                subMenuIcon: 'ic-arrested-pending',
                url: 'detenidos/salidas-pendientes',
                idMenu: 46,
                idModules: MODULES_ENUM.PENDING_EXITS
            },
            {
                subMenuName: 'NAV.arrestedHistory',
                subMenuIcon: 'ic-contact',
                url: 'detenidos/historico',
                idMenu: 38,
                idModules: MODULES_ENUM.DETAINEES_HISTORY
            }
        ]
    },
    //* JUZGADO CÍVICO
    {
        menuName: 'NAV.civicCourt',
        menuIcon: 'ic-audiencia',
        url: '',
        idMenu: [62, 63, 64, 65, 66, 67, 68],
        open: false,
        idModules: [MODULES_ENUM.CIVIC_COURT],
        subMenu: [
            {
                subMenuName: 'NAV.disposition',
                subMenuIcon: 'ic-jail',
                url: 'puesta-a-disposicion',
                idMenu: 62,
                idModules: MODULES_ENUM.CIVIC_COURT
            },
            {
                subMenuName: 'NAV.offenderRights',
                subMenuIcon: 'ic-jail',
                url: 'derecho-de-infractor',
                idMenu: 63,
                idModules: MODULES_ENUM.CIVIC_COURT
            },
            {
                subMenuName: 'NAV.initialInterview',
                subMenuIcon: 'ic-jail',
                url: 'entrevista-inicial',
                idMenu: 64,
                idModules: MODULES_ENUM.CIVIC_COURT
            },
            {
                subMenuName: 'NAV.releaseTicket',
                subMenuIcon: 'ic-jail',
                url: 'boleta-libertad',
                idMenu: 65,
                idModules: MODULES_ENUM.CIVIC_COURT
            },
            {
                subMenuName: 'NAV.recordOfFacts',
                subMenuIcon: 'ic-jail',
                url: 'constancia-hechos',
                idMenu: 66,
                idModules: MODULES_ENUM.CIVIC_COURT
            },
            {
                subMenuName: 'NAV.releaseCertificateTfc',
                subMenuIcon: 'ic-jail',
                url: 'constancia-cumplimiento-tfc',
                idMenu: 67,
                idModules: MODULES_ENUM.CIVIC_COURT
            },
            {
                subMenuName: 'NAV.administrativeFile',
                subMenuIcon: 'ic-jail',
                url: 'expediente-administrativo',
                idMenu: 68,
                idModules: MODULES_ENUM.CIVIC_COURT
            }
        ]
    },
    //* LLAMADAS DE AUXLIO
    {
        menuName: 'NAV.distressCall',
        menuIcon: 'ic-llamadaAuxilio',
        url: 'llamadas/auxilio',
        idMenu: [34],
        open: false,
        idModules: [MODULES_ENUM.DISTRESS_CALLS],
        subMenu: []
    },
    //* TAMIZAJE
    {
        menuName: 'NAV.tamizaje',
        menuIcon: 'ic-tamizaje',
        url: 'tamizaje',
        idMenu: [35],
        open: false,
        idModules: [MODULES_ENUM.SCREENING],
        subMenu: []
    },
    //* DENUNCIAS
    // {
    //     menuName: 'NAV.complaints',
    //     menuIcon: 'ic-complaints',
    //     url: 'denuncias',
    //     idMenu: [41],
    //     open: false,
    //     idModules: [40],
    //     subMenu: []
    // }
];